import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    OnDestroy,
    Output,
    TemplateRef,
    ViewEncapsulation,
} from '@angular/core';

@Component({
    selector: 'cmps-coaching-focus-item',
    template: ` <div
        class="cmps-coaching-focus-item--labels"
        [class.cmps-coaching-focus-item--focused-labels]="hasDetailAction"
        [attr.role]="hasDetailAction ? 'button' : ''"
        [attr.tabindex]="hasDetailAction ? 0 : -1"
        (click)="hasDetailAction && detailAction.emit($event)"
        (keydown.enter)="hasDetailAction && detailAction.emit($event)"
        (keydown.space)="hasDetailAction && $event.preventDefault()"
        (keyup.space)="hasDetailAction && detailAction.emit($event)"
    >
        <div
            class="cmps-coaching-focus-item--behaviour"
            *ngIf="!behaviour && !subBehaviour"
        >
            <span>{{ unfocusedLabel }}</span>
        </div>
        <div
            class="cmps-coaching-focus-item--behaviour"
            *ngIf="behaviour"
        >
            <span>{{ behaviourLabel }}&nbsp;{{ behaviour }}</span>
            <div
                class="cmps-coaching-focus-item--actions"
                *ngIf="hasEditAction || hasAddAction"
            >
                <button
                    class="cmps-icon-button--no-bg"
                    cmpsIconButton
                    [cmpsTooltipTrigger]="editActionTooltip"
                    [openDelay]="750"
                    (click)="$event.stopPropagation(); editAction.emit($event)"
                    *ngIf="hasEditAction"
                >
                    <cmps-icon svgIcon="__internal:pencil"></cmps-icon>
                </button>
                <button
                    class="cmps-icon-button--no-bg"
                    cmpsIconButton
                    [cmpsTooltipTrigger]="addActionTooltip"
                    [openDelay]="750"
                    (click)="$event.stopPropagation(); addAction.emit($event)"
                    *ngIf="hasAddAction"
                >
                    <cmps-icon svgIcon="__internal:loupe"></cmps-icon>
                </button>
            </div>
        </div>
        <div
            class="cmps-coaching-focus-item--sub-behaviour"
            *ngIf="subBehaviour"
        >
            <span>{{ subBehaviourLabel }}&nbsp;{{ subBehaviour }}</span>
        </div>
    </div>`,
    host: {
        class: 'cmps-coaching-focus-item',
    },
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
})
export class CmpsFocusItemComponent implements OnDestroy {
    @Input() unfocusedLabel: string;
    @Input() behaviourLabel: string;
    @Input() behaviour: string;
    @Input() subBehaviourLabel: string;
    @Input() subBehaviour: string;
    @Input() hasDetailAction: boolean;
    @Output() detailAction: EventEmitter<MouseEvent | KeyboardEvent>;
    @Input() hasEditAction: boolean;
    @Input() editActionTooltip: string | TemplateRef<any>;
    @Output() editAction: EventEmitter<MouseEvent | KeyboardEvent>;
    @Input() hasAddAction: boolean;
    @Input() addActionTooltip: string | TemplateRef<any>;
    @Output() addAction: EventEmitter<MouseEvent | KeyboardEvent>;

    constructor() {
        this.detailAction = new EventEmitter();
        this.editAction = new EventEmitter();
        this.addAction = new EventEmitter();
    }

    ngOnDestroy(): void {
        this.detailAction.complete();
        this.editAction.complete();
        this.addAction.complete();
    }
}
